import React from 'react';
import NavigationMenu from "./NavigationMenu"
import NavigationUserMenu from "./NavigationUserMenu"

class Navigation extends React.Component {
	render() {
		return (
			<nav className="navbar navbar-default navbar-static-top" role="navigation">
				<div className="navbar-header">
					<button type="button" className="navbar-toggle" data-toggle="collapse"
						data-target=".navbar-collapse">
						<span className="sr-only">Toggle navigation</span>
						<span className="icon-bar" />
						<span className="icon-bar" />
						<span className="icon-bar" />
					</button>
					<a className="navbar-brand" href="/">
						<img src="/static/img/wtlogo.png" className="img-responsive" alt="trend" style={{height: "2rem"}}/>
					</a>
				</div>
				<NavigationMenu />
				<NavigationUserMenu />
			</nav>
		);
	}
}

export default Navigation;





// WEBPACK FOOTER //
// ./src/modules/navigation/Navigation.js